import type { ReactNode, VoidFunctionComponent } from 'react';
import styles from './DetailsPanel.module.less';

export type DetailsPanelListRowProps = {
  /**
   * The left-aligned label for each line.
   */
  label: string;
  /**
   * The right-aligned content for each line. May contain any valid ReactNode.
   */
  content: ReactNode;
};

/**
 * A single "row" of the DetailsPanelList.
 * Contains a left-aligned label (string) and any
 * generic inline content which is right-aligned.
 */
const DetailsPanelListRow: VoidFunctionComponent<DetailsPanelListRowProps> = ({ label, content }) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}</span>
    <span className={styles.content}>
      {content}
    </span>
  </div>
);

export default DetailsPanelListRow;
